module.exports = __webpack_public_path__ + "static/media/14.d644d6e9.jpg";